module.exports = __webpack_public_path__ + "img/slide-45.a93db2ab.jpeg";